module.exports = __webpack_public_path__ + "static/media/4.9c6fb278.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/4.png
// module id = 662
// module chunks = 0